import * as React from "react";
import { MenuListComponentProps, OptionTypeBase } from "react-select";
import { FixedSizeList } from "react-window";

export default class OptimizedMenuList extends React.Component<
  MenuListComponentProps<OptionTypeBase, true>
> {
  private readonly height = 40;

  public render() {
    const {
      options,
      children,
      maxHeight,
      getValue,
    }: { options: any; children: any; maxHeight: any; getValue: any } = this.props;
    const selectedValues: any = getValue();
    const initialOffset =
      selectedValues && selectedValues[0] ? options.indexOf(selectedValues[0]) * this.height : 0;

    return (
      <FixedSizeList
        height={maxHeight}
        itemCount={children!["length"]}
        itemSize={this.height}
        initialScrollOffset={initialOffset}
        width={""} // 100% width
      >
        {({ index, style }: { index: number; style: any }) => (
          <div className="option-wrapper" style={style}>
            {children![index]}
          </div>
        )}
      </FixedSizeList>
    );
  }
}
